import { alpha, Box, styled } from "@mui/material";

export const ImageCountBadge = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 8,
  right: 8,
  backgroundColor: alpha(theme.palette.customColors.black, 0.9),
  color: "white",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  borderRadius: Number(theme.shape.borderRadius) * 3,
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  zIndex: 1,
  marginTop: theme.spacing(1)
}));
